import * as ActionTypes from '../ActionTypes';
import * as WebService from '../WebService';
import { CACHE_ACCESS_TOKEN, CACHE_BROKER_INFO, CACHE_SESSION_USER } from '../../../constants/Profile';
import HttpUtils from '../../../utils/HttpUtils';
import { message } from 'antd';
import { RoutePath } from "../../../constants/RoutePath";
import { APP_REFRESH_USER_INFO } from '../../../constants/ActionTypes';

export function refreshUser(user) {
    return {
        type: ActionTypes.USER_REFRESH_USER,
        user: user
    }
}
export function refreshCreateUser(user) {
    return {
        type: ActionTypes.USER_REFRESH_CREATE_USER,
        createUser: user
    }
}

export function refreshSessionUser(sessionUser) {
    return {
        type: ActionTypes.USER_REFRESH_SESSION_USER,
        sessionUser: sessionUser
    }
}

export function refreshSearchCondition(searchCondition) {
    return {
        type: ActionTypes.USER_REFRESH_SEARCH_CONDITION,
        searchCondition: searchCondition
    }
}

export function toggleDetailModal(showDetailModal) {
    return {
        type: ActionTypes.USER_TOGGLE_DETAIL_MODAL,
        showDetailModal: showDetailModal
    }
}

export function togglePasswordChangeModal(show) {
    return {
        type: ActionTypes.USER_TOGGLE_PASSWORD_CHANGE_MODAL,
        showPasswordChangeModal: show
    }
}

export function togglePasswordResetModal(show) {
    return {
        type: ActionTypes.USER_TOGGLE_PASSWORD_RESET_MODAL,
        showPasswordResetModal: show
    }
}

export function toggleWXQRCodeModal(show) {
    return {
        type: ActionTypes.USER_TOGGLE_WX_QR_CODE_MODAL,
        showWXQRCodeModal: show
    }
}

export function getUserWXQRCode(id, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        let requestURL = WebService.getUserWXQRCode.replace("{id}", id);

        HttpUtils.get(requestURL, (response) => {
            dispatch({ type: ActionTypes.USER_REFRESH_WX_QR_CODE, wxQRCode: response.data });
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function getUser(id, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        let requestURL = WebService.getUser.replace("{id}", id);

        HttpUtils.get(requestURL, (response) => {
            dispatch(refreshUser(response.data));
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function getSessionUser(formatMessage, router) {
    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });
        HttpUtils.get(WebService.getSessionUser, (response) => {
            dispatch(refreshUser(response.data));
            dispatch({ type: ActionTypes.USER_REFRESH_SESSION_USER, sessionUser: response.data });
            localStorage.setItem(CACHE_SESSION_USER, JSON.stringify(response.data));

            if (router) {
                // 获得重定向参数
                let redirect = HttpUtils.getQueryString("redirect");
                if (redirect !== undefined && redirect !== "") {
                    window.location.href = redirect;
                } else {
                    window.location.href = window.location.origin;
                }
            }

            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function searchUsers(condition, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        HttpUtils.post(WebService.searchUsers, condition, (response) => {
            dispatch({
                type: ActionTypes.USER_SEARCH,
                users: response.data,
                searchCondition: condition,
                pagination: response.pagination
            });

            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}



export function createUser(user, condition, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        HttpUtils.post(WebService.createUser, user, (response) => {
            dispatch(toggleDetailModal(false));
            dispatch(refreshUser({}));
            dispatch(searchUsers(condition, formatMessage));
            message.success(formatMessage({ id: "ACCOUNT_USER_MSG_CREATE_SUCCESS" }));
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function registerUser(user, router, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        HttpUtils.post(WebService.registerUser, user, (response) => {
            dispatch(refreshUser({}));
            message.success(formatMessage({ id: "ACCOUNT_USER_MSG_CREATE_SUCCESS" }));
            router.navigate(RoutePath.ACCOUNT_USER_LOGIN_PASSWORD.path);
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function resetPassword(user, router, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        HttpUtils.put(WebService.resetPassword, user, (response) => {
            message.success(formatMessage({ id: "ACCOUNT_USER_MSG_PASSWORD_RESET_SUCCESS" }));
            router.navigate(RoutePath.ACCOUNT_USER_LOGIN_PASSWORD.path);
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function resetDefaultPassword(user, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        const requestUrl = WebService.resetDefaultPassword.replace("{id}", user.id);

        HttpUtils.put(requestUrl, user, (response) => {
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
            dispatch(togglePasswordResetModal(false));
            message.success(formatMessage({ id: "ACCOUNT_USER_MSG_PASSWORD_RESET_SUCCESS" }));
        }, (response) => {
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, formatMessage)
    }
}

export function updateUser(user, condition, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        let requestURL = WebService.updateUser.replace("{id}", user.id);

        HttpUtils.put(requestURL, user, (response) => {
            dispatch(toggleDetailModal(false));
            dispatch(refreshUser({}));
            dispatch(searchUsers(condition, formatMessage));
            message.success(formatMessage({ id: "ACCOUNT_USER_MSG_UPDATE_SUCCESS" }));
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function updateSessionUser(user, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        HttpUtils.put(WebService.updateSessionUser, user, (response) => {
            dispatch(refreshUser(response.data));
            dispatch(refreshSessionUser(response.data));
            message.success(formatMessage({ id: "ACCOUNT_USER_MSG_UPDATE_SUCCESS" }));
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function updateSessionUserPassword(user, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        HttpUtils.put(WebService.updateSessionUserPassword, user, (response) => {
            dispatch(togglePasswordChangeModal(false));
            dispatch(refreshUser(response.data));
            message.success(formatMessage({ id: "ACCOUNT_USER_MSG_UPDATE_SUCCESS" }));
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function deleteUser(user, condition, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });
        let requestURL = WebService.deleteUser.replace("{id}", user.id);
        HttpUtils.delete(requestURL, {}, (response) => {
            dispatch(searchUsers(condition, formatMessage));
            message.success(formatMessage({ id: "ACCOUNT_USER_MSG_DELETE_SUCCESS" }));
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage);
    }
}

export function login(user, router, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        HttpUtils.post(WebService.createToken, user, (response) => {
            localStorage.setItem(CACHE_ACCESS_TOKEN, response.data.accessToken);
            dispatch(getSessionUser(formatMessage, router));
            // // 获得重定向参数
            // let redirect = HttpUtils.getQueryString("redirect");
            // if (redirect !== undefined && redirect !== "") {
            //     // redirect = HttpUtils.addQueryString(redirect, "token", response.data.accessToken);
            //     window.parent.location.href = redirect;
            // } else {
            //     router.push(RoutePath.CMS_SITE_LIST.path);
            // }
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function logout() {
    return dispatch => {
        dispatch(refreshUser({}));
        dispatch({ type: ActionTypes.USER_REFRESH_SESSION_USER, sessionUser: {} });
        localStorage.removeItem(CACHE_SESSION_USER)
        localStorage.removeItem(CACHE_ACCESS_TOKEN);
        dispatch({ type: APP_REFRESH_USER_INFO, userInfo: null });
    }
}

export function getCreateUser(id, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        let requestURL = WebService.getUser.replace("{id}", id);

        HttpUtils.get(requestURL, (response) => {
            dispatch(refreshCreateUser(response.data));
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

export function getBroker(id) {

    return dispatch => {
        dispatch({ type: ActionTypes.USER_LOADING, isLoading: true });

        let requestURL = WebService.getUserByOpenAPI.replace("{id}", id);

        HttpUtils.get(requestURL, (response) => {
            dispatch(refreshBroker(response.data));
            localStorage.setItem(CACHE_BROKER_INFO, JSON.stringify(response.data));
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
        }, (response) => {
            dispatch({ type: ActionTypes.USER_LOADING, isLoading: false });
            console.log(response);
        })
    }
}

export function refreshBroker(broker) {
    return {
        type: ActionTypes.USER_REFRESH_BROKER,
        broker: broker
    }
}